export const getTestimonial = 'feedback';
export const deleteTestimonial = 'feedback/';
export const addTestimonial = 'feedback';
export const updateTestimonial = 'feedback/';
